import {Box, Typography} from "@mui/material";
import ImageNotSupportedOutlinedIcon from "@mui/icons-material/ImageNotSupportedOutlined";
import {useTheme} from "@mui/material/styles";
import {themeLogoSvg} from "../helper/logo";

interface Props {
    content?: string | null;
    name?: string;
    size?: number;
}

const getLogoSource = (content?: string | null): string => {
    const value = content?.trim();

    if (!value) {
        return "";
    }

    if (
        value.startsWith("data:image/") ||
        value.startsWith("http://") ||
        value.startsWith("https://") ||
        value.startsWith("/")
    ) {
        return value;
    }

    if (value.startsWith("<svg")) {
        return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(value)}`;
    }

    return value;
};

const CourseLogoPreview = ({
                               content,
                               name = "Course logo",
                               size = 56,
                           }: Props) => {
    const theme = useTheme();
    const source = getLogoSource(content ? themeLogoSvg(content, theme) : content);

    return (
        <Box
            sx={(theme) => ({
                width: size,
                height: size,
                borderRadius: 2.5,
                border: `1px solid ${theme.palette.divider}`,
                backgroundColor:
                    theme.palette.mode === "dark"
                        ? theme.palette.background.paper
                        : "#f8fafc",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
                flexShrink: 0,
                p: 0.75,
            })}
        >
            {source ? (
                <Box
                    component="img"
                    src={source}
                    alt={name}
                    sx={{
                        display: "block",
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                    }}
                />
            ) : (
                <Box sx={{textAlign: "center", color: "text.secondary"}}>
                    <ImageNotSupportedOutlinedIcon sx={{fontSize: size * 0.35}}/>

                    {size >= 100 && (
                        <Typography
                            variant="caption"
                            sx={{
                                display: "block",
                                mt: 0.5,
                            }}
                        >
                            No preview
                        </Typography>
                    )}
                </Box>
            )}
        </Box>
    );
};

export default CourseLogoPreview;